import React from 'react'
import { render } from "react-dom"
import Carousel from "./Carousel"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import Link from 'gatsby-link'

import band01 from '../images/band01.png'
import merch01 from '../images/merch01.png'
import band02 from '../images/band02.png'

class Main extends React.Component {
  render() {

    let close = <div className="close" onClick={() => {this.props.onCloseArticle()}}></div>

    return (
      <div id="main" style={this.props.timeout ? {display: 'flex'} : {display: 'none'}}>

        <article id="intro" className={`${this.props.article === 'gigs' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h2 className="major">Gigs</h2>
          <span className="image main"><img src={band01} alt="" /></span>
          <p>Most shows are private functions but if you want to crash one, knock yourself out.</p>
          <p>ROCK GOD UPDATE: finally had the cops called on us at Pete's VIP Xmas party. So we have that going for us, which is nice.</p>
          <h3>26 Apr 2019 | Paul's 60th @ the Lord Alfred</h3>
          <h3>18 May 2019 | Purgapalooza 2019</h3>
          <h3>TBC Aug 2019 | McDowall SS Trivia Night</h3>
          <h3>25 Dec 2021 | Wembley Arena (probably)</h3>
          {close}
        </article>

        <article id="work" className={`${this.props.article === 'merch' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h2 className="major">Merch</h2>
          <span className="image main"><img src={merch01} alt="" /></span>
          <p>James is a Dave Matthews Band tragic and insists on following their lead by producing a sticker/poster for every gig we do. Collect the whole set!</p>
          <p>All our merch is dropshipped from <a href="https://www.redbubble.com/people/jradvan/collections/882180-please-stop" target="_blank">Redbubble</a>.
            Their products are great quality and they ship anywhere. There's clothes, stickers, prints, etc. Tea towels and underpants probably on the roadmap.</p>
          <div>
            <Carousel />
          </div>
          <p>Wear some Please Stop merch to a gig and we'll autograph your boobs with a marker pen! To be fair we'll probably do that anyway if you ask. No Colin, not you.</p>
          {close}
        </article>

        <article id="about" className={`${this.props.article === 'about' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h2 className="major">About</h2>
          <span className="image main"><img src={band02} alt="" /></span>
          <p>Please Stop formed in 2016 with Nick (drums), Pete (lead guitar), Stu (bass) and James (vocal/rhythm guitar), whose kids are all friends from school and Scouts.</p>
          <p>Playing a heady mix of 70s/80s/90s rock with smatterings of blues, punk and aussie classics, we're not afraid to put our own spin on your favourites
          (such as our Violent Femmes-esque cover of Leonard Cohen/Jeff Buckley's "Hallelujah").</p>
          <p>As legend has it the band was named by our wives, who agonized for some time between "Please Stop" and "Honey The Kids Are Trying To Sleep".</p>
          <p>Things most frequently shouted at our gigs include "what? I can't hear you", chants of "please stop" and the heckle "play something we can dance to" - the latter
            usually triggering a "Blister in the Sun" powered quadragenarian mosh pit which says it all really.</p>
          <p>Widely regarded as being "loud" and "surprisingly ok", the group is held back from runaway international success only by our relaxed attitude to rehearsal,
           lack of original material and fear of commitment. Also our backs hurt.</p>
          {close}
        </article>

        <article id="contact" className={`${this.props.article === 'connect' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''}`} style={{display:'none'}}>
          <h2 className="major">Connect</h2>
          <ul className="icons">
            <li>
              <a href="https://www.facebook.com/pleasestopband" target="_blank" className="icon fa-facebook"><span className="label">Facebook</span></a>
              <h3>Message or book us on Facie</h3>
            </li>
            <li>
              <a href="#" className="icon fa-spotify"><span className="label">Spotify</span></a>
              <h3>Original releases (when we have some)</h3>
            </li>
            <li>
              <a href="https://soundcloud.com/please-stop-band" target="_blank" className="icon fa-soundcloud"><span className="label">Soundcloud</span></a>
              <h3>Jam tracks and live recordings</h3>
            </li>
          </ul>
          {close}
        </article>

      </div>
    )
  }
}

Main.propTypes = {
  route: React.PropTypes.object,
  article: React.PropTypes.string,
  articleTimeout: React.PropTypes.bool,
  onCloseArticle: React.PropTypes.func,
  timeout: React.PropTypes.bool
}

export default Main



// WEBPACK FOOTER //
// ./src/components/Main.js